import { AxiosInstanceProvider } from '../../../../core/hooks';
import { ChartSettings } from '../../../chart-settings/model';
import { CpeMonitoredDevicesQuery } from '../../config';
import { DeviceCpuMeasurementModel } from '../../model';

interface GetCpuMeasurementsPayloadModel {
  customerId: number;
  deviceId: string;
  chartSettings: ChartSettings;
}

export const getCpuMeasurements = async (
  axios: AxiosInstanceProvider,
  { customerId, deviceId, chartSettings }: GetCpuMeasurementsPayloadModel,
): Promise<DeviceCpuMeasurementModel[]> => {
  const url = CpeMonitoredDevicesQuery['GetCpuMeasurements'].url
    .replace('{customerId}', customerId.toString(10))
    .replace('{deviceId}', deviceId);
  const requestConfiguration = {
    params: {
      timespan: chartSettings.timespan,
      resolution: chartSettings.resolution,
    }
  };
  const response = await axios().get<DeviceCpuMeasurementModel[]>(url, requestConfiguration);
  return response.data;
};